import { IPhoneCall, Maybe } from 'types/graphqlTypes'
import { getTimeAgoShort } from 'utils/formatDatetime'

export const formatLastPhoneCall = (
  lastPhoneCall: Maybe<Pick<IPhoneCall, 'agentName' | 'disposition' | 'startedAt'>>
): string | null => {
  const { agentName, disposition, startedAt } = lastPhoneCall ?? {}

  if (startedAt) {
    const timeAgo = getTimeAgoShort(startedAt)
    let callString = `Called ${timeAgo}`

    if (agentName) {
      callString += ` by ${agentName}`
    }

    if (disposition) {
      callString += ` - ${disposition}`
    }

    return callString
  }

  return null
}
